import React from 'react';
import GameFlow from './components/GameFlow';
import './styles/animations.css';

export default function App() {
  return <GameFlow />;
}
